import { Box } from '@chakra-ui/react';
import React from 'react';

import 'source/borrower/borrower.scss';

export const BorrowerTasksView = () => {
  return (
    <>
      <Box fontSize={{ base: '18px', sm: '24px', md: '36px' }}>
        Coming soon!
      </Box>
    </>
  );
};
